import axios from "axios";
import { BaseAPI } from "./BaseAPI";

export class AccountAPI extends BaseAPI {
  async authorize(type, code, redirect_uri, code_verifier) {
    const { data } = await axios.post(`${this._getContext()}/authorize`, null, {
      params: {
        type,
        code,
        redirect_uri,
        code_verifier,
      },
    });
    return data;
  }

  async accessToken(type, token) {
    const { data } = await axios.post(
      `${this._getContext()}/access_token`,
      null,
      {
        params: {
          type,
          token,
        },
      }
    );
    return data;
  }

  async refreshToken(type, token) {
    const { data } = await axios.post(
      `${this._getContext()}/refresh_token`,
      null,
      {
        params: {
          type,
          token,
        },
      }
    );
    return data;
  }

  /**
   * 獲取 Jwt Token
   * @param {('one-account' | 'association-business')} originPlatform
   */
  async getAliToken(originPlatform) {
    const { data } = await axios.get(`${this._getContext()}/api/v1/gov-mo-token`, {
      params: {
        originPlatform,
      },
    });
    return data;
  }

  async getProfile() {
    const { data } = await axios.get(`${this._getContext()}/profile`);
    return data;
  }
}

export default new AccountAPI();
